import React from 'react';
import { useTranslation } from '../hooks/useTranslation.js';
import Footer from '../components/Footer.jsx';
import EventList from '../components/EventList.jsx';
import { getEvents, groupByYear } from '../utils/events.js';

// Upcoming events first, then the past ones by year, newest first. The page
// grows with the registry; nothing here names a single event.
const EventsPage = () => {
  const { getPageTranslations, currentLang } = useTranslation('events');
  const t = getPageTranslations('events');
  const { upcoming, past } = getEvents();

  return (
    <div className="min-h-screen bg-bg-main text-text-primary">
      <main className="site-main">
        <section className="site-hero site-hero--single">
          <div className="site-hero__copy">
            <h1 className="site-title">{t.title}</h1>
          </div>
        </section>

        {upcoming.length > 0 && (
          <section className="signal-section">
            <header className="signal-section-header">
              <h2>{t.upcoming}</h2>
            </header>
            <EventList events={upcoming} texts={t.items} language={currentLang} />
          </section>
        )}

        {past.length > 0 && (
          <section className="signal-section">
            <header className="signal-section-header">
              <h2>{t.past}</h2>
            </header>
            {groupByYear(past).map((group) => (
              <div className="event-year" key={group.year}>
                <h3 className="event-year__label">{group.year}</h3>
                <EventList events={group.events} texts={t.items} language={currentLang} />
              </div>
            ))}
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default EventsPage;
